import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { useDispatch, useSelector } from 'react-redux'
import { periodState, loginTypeState } from '@/features/authSlice'
import { RootState } from '@/app/store'

const usePeriod = () => {
  const router = useRouter()
  const dispatch = useDispatch()
  const [PeriodState, setPeriodState] = useState(undefined)
  const datadataCampain = useSelector(
    (campainState: RootState) => campainState.campain.campaign
  )

  const handlePeriod = (campaign) => {
    if (campaign === 'notice') {
      localStorage.setItem(
        `${process.env.NEXT_PUBLIC_SERVICE_NAME}-period`,
        'false'
      )

      if (router.pathname == '/notice') {
        dispatch(periodState(true))
      } else {
        location.href = `${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}/notice`
      }

      return
    }

    if (campaign === false) {
      localStorage.setItem(
        `${process.env.NEXT_PUBLIC_SERVICE_NAME}-period`,
        'false'
      )

      if (router.pathname == '/period') {
        dispatch(periodState(true))
      } else {
        location.href = `${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}/period`
      }
    }
  }

  useEffect(() => {
    if (datadataCampain.campaignEndAt !== '') {
      setPeriodState(datadataCampain)
    }
  }, [datadataCampain])

  useEffect(() => {
    if (PeriodState !== undefined) {
      dispatch(loginTypeState(PeriodState.loginType))

      if (PeriodState.period === false) {
        dispatch(periodState(false))
        handlePeriod(PeriodState.period)
        return
      }

      if (PeriodState.outOfTermMessage !== null) {
        localStorage.removeItem(
          `${process.env.NEXT_PUBLIC_SERVICE_NAME}-period`
        )

        dispatch(periodState(false))
        handlePeriod('notice')

        return
      }

      localStorage.removeItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-period`)
      dispatch(periodState(true))

      return
    }
  }, [PeriodState])

  useEffect(() => {
    router.events.on('routeChangeComplete', handlePeriod)
    router.events.on('routeChangeStart', handlePeriod)
    return () => {
      router.events.off('routeChangeComplete', handlePeriod)
      router.events.off('routeChangeStart', handlePeriod)
    }
  }, [router.events])
}

export default usePeriod
